import type { Category } from '../types';

export function sortCategoriesByWeight(categories: Category[]): Category[] {
  return [...categories].sort(
    (left, right) =>
      left.sortingWeight - right.sortingWeight ||
      left.name.localeCompare(right.name) ||
      left.id - right.id,
  );
}
